module.exports = __webpack_public_path__ + "img/paihangbang.ff186e99.png";